import { cn } from '@/lib/utils';

export const MOBILE_EDGE_BLEED_CLASSES =
  'max-md:-mx-5 max-md:w-[calc(100%+2.5rem)]';

export const MOBILE_PAGE_EDGE_INSET_CLASSES =
  'max-md:first:pl-4 max-md:last:pr-4';

export const PEEK_PAGE_WIDTH_CLASS =
  'w-[calc(100%_-_var(--paged-carousel-peek,0px))]';

export const VIEWPORT_CLASSES = cn(
  'flex w-full items-start snap-x snap-mandatory overflow-x-auto',
  '[-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden',
  'motion-safe:scroll-smooth'
);
